// extracted by mini-css-extract-plugin
export default {"progressContainer":"ProgressBar_progressContainer__fiIgc","progressTitle":"ProgressBar_progressTitle__njf4f"};